<template>
  <div>
    <div class="panel animated fadeInRightBig">
      <div class="panel-heading">
        <div class="panel-title">
          <span>
            <b>Regionais</b>
            <i class="fa fa-user-circle" style="float: right; margin-top: 6px; font-size: 21px"></i>
            <hr />
          </span>
        </div>
      </div>
      <div class="panel-body">
        <form id="form">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label><span class="required">*</span> Nome:</label>
              <input v-model="regional.name" class="form-control">
            </div>
          </div>

          <div class="block text-right">
            <a class="btn btn-add" @click="save">
              Salvar
              <i class="fa fa-save ml-2"></i>
            </a>
            <router-link to="/justifications" class="btn btn-back">
              <i class="fa fa-arrow-left mr-2"></i> Voltar
            </router-link>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b><span class="required">*</span> Campos Obrigatórios</b>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      regional: {
        name: "",

      },

      errors: undefined,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const api = this.$store.state.api + "regionals";
      const self = this;

      let fd = new FormData();

      fd.append("name", self.regional.name);

      self.$http
        .post(api,fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Regional cadastrada com sucesso`,
            "success"
          );
          this.$router.push("/regionals");
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () { },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Regional/Add.vue